module.exports = __webpack_public_path__ + "static/media/skphome.295bc2fd.PNG";